import { ImageIcon } from 'lucide-react';

/**
 * CapturaProducto — una captura del panel dentro de su marco.
 *
 * El marco (tarjeta blanca, borde, esquinas redondeadas y sombra) es el mismo
 * del diseño y va aquí y no en quien la monta: son siete en la misma página y
 * copiarlo siete veces es cómo acaba una con el borde distinto.
 *
 * ── SIN PROPORCIÓN FIJA ─────────────────────────────────────────────────────
 *
 * Las capturas van de 2,43 de proporción (el ranking de locales, muy apaisado)
 * a 0,69 (el formulario de publicación, vertical). Forzarlas a un `aspect-ratio`
 * común las recortaría o las deformaría, así que cada una conserva la suya y el
 * hueco lo reserva `width`/`height` del propio `<img>`: con los dos puestos, el
 * navegador ya sabe cuánto alto dejar antes de descargarla y la página no da el
 * salto al cargar.
 *
 * ── MIENTRAS NO HAY CAPTURA ─────────────────────────────────────────────────
 *
 * Sin `src` pinta un marcador con la proporción que se le diga. A propósito NO
 * es un `<img>` roto: el icono del navegador se lee como un fallo de la página,
 * y esto es un espacio reservado. Sirve para montar una sección antes de que
 * exista su captura, que es como se construyó esta página.
 *
 * `prioritaria` quita el `loading="lazy"`: la del hero entra en la primera
 * pantalla y diferirla es justo lo que hace que la página parezca lenta.
 */
export default function CapturaProducto({
  src, alt, ancho, alto, proporcion = '16/10', prioritaria = false, pie, className = '',
}) {
  return (
    <div className={className}>
      <div className="bg-white border border-v3-line rounded-[20px] v3-shadow p-2.5">
        {src ? (
          <img
            src={src}
            alt={alt}
            width={ancho}
            height={alto}
            loading={prioritaria ? undefined : 'lazy'}
            decoding="async"
            className="block w-full h-auto rounded-xl"
          />
        ) : (
          <div
            aria-hidden="true"
            className="w-full rounded-xl bg-gradient-to-br from-v3-sunken to-v3-track flex items-center justify-center"
            style={{ aspectRatio: proporcion }}
          >
            <ImageIcon className="w-8 h-8 text-v3-faint" strokeWidth={1.5} />
          </div>
        )}
      </div>
      {pie ? <p className="text-[12.5px] text-v3-faint text-center mt-3">{pie}</p> : null}
    </div>
  );
}
